<template>
  <b-container class="search-area" fluid="lg">
    <form>
      <b-form-row class="mb-3">
        <b-col cols="3">
          <h3 class="common__search-title">University Name</h3>
          <SelectUniversityInput class="form-control" v-model="conditions.university" />
        </b-col>
      </b-form-row>
      <b-form-row class="mb-3">
        <b-col cols="3">
          <template v-if="conditions.university">
            <h3 class="common__search-title">Campus Name</h3>
            <CampusesInput
              v-model="conditions.campuses"
              :belongsToUniversity="conditions.university"
            />
          </template>
        </b-col>
      </b-form-row>
      <div class="d-flex justify-content-end">
        <b-button
          pill
          variant="secondary"
          @click="reset"
          class="mr-2"
        >
          Reset
        </b-button>
        <b-button
          pill
          variant="primary"
          @click="search"
        >
          Search
        </b-button>
      </div>
    </form>
  </b-container>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import _ from 'lodash';
import SelectUniversityInput from '@/components/parts/inputItem/SelectUniversityInput.vue';
import CampusesInput from '@/components/parts/inputItem/CampusesInput.vue';
import { BoothConditions } from '@/store/booths/types';

const initialConditions = {
  university: null,
  campuses: [],
}

@Component({
  components: {
    SelectUniversityInput,
    CampusesInput,
  },
})
export default class BoothSearch extends Vue {
  private conditions: BoothConditions = _.cloneDeep(initialConditions)

  private search() {
    this.$emit('changeConditions', this.conditions)
  }

  reset() {
    this.conditions = _.cloneDeep(initialConditions)
    this.search()
  }
}
</script>
